<template>
  <div class="dialog_warp" style="height: 555px;max-height: 555px;">
    <div class="electronic_contract">
      <iframe :src="billUrl" frameborder="0" width="100%" height="500"></iframe>
    </div>
    <div class="text-center" style="margin-top: 10px;">
      <el-button type="success" size="small" @click="close">完成查看</el-button>
    </div>
  </div>
</template>

<script>
  import * as global from '../config/mUtils'
  import * as getData from "../service/getData";

  export default {
    data() {
      return {
        billUrl: ''
      }
    },
    mounted() {
      this.init();
    },
    props: ['contractId', 'contractType'],
    methods: {
      close() {
        this.$emit('closeDialog')
      },
      init() {
        this.billUrl = '';
        //获取电子合同详情contractType合同类型 (1企业租赁 2企业物业 4公寓租赁 5公寓物业 )
        getData.fileTemplate({contractId:this.contractId,contractType:this.contractType}).then((res) => {
          if (res.data.code != 'success') {
            this.$message({
              type: 'error',
              message: res.data.msg || res.data.message
            });
            return
          }
          this.billUrl = 'https://view.officeapps.live.com/op/view.aspx?src=' + res.data.data.data;
        });
      },
    },
    components: {},
    computed: {},
    watch: {
      id(val) {
        if (val) {
          this.init();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .electronic_contract {
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/electronic-contract.vue